import styled from "styled-components";

export const MainContainer = styled.div`
  width: 100%;
  max-width: 1600px;

  background-color: #142425;
  position: relative;
  display: flex;
  flex-direction: column;

  align-items: center;
  box-sizing: border-box;
  &::before {
    content: "";
    position: absolute;
    background-color: #a2a087;
    bottom: 0;
    left: 50px;
    width: 2px;
    height: 100%;
  }
  &::after {
    content: "";
    position: absolute;
    background-color: #a2a087;
    bottom: 0;
    right: 50px;
    width: 2px;
    height: 100%;
  }
  p {
    font-family: "Josefin Sans", sans-serif;
    /* Kum – Ristorante Casual Fine Dining è il cuore gastronomico di The Padel Resort a Como: un luogo dove gusto, benessere e tradizione si incontrano.  Il nome richiama le radici del territorio – “cum” in dialetto comasco – e racconta una filosofia culinaria che celebra la ricchezza del Lago e delle sue stagioni. Nasce con una visione chiara: offrire un’esperienza di Casual Fine Dining che celebra la convivialità, la bellezza del territorio e l’equilibrio tra semplicità e raffinatezza. */

    font-style: normal;
    font-weight: 300;

    line-height: 25px;
    padding: 0;
  }
  @media screen and (max-width: 900px) {
    &::after {
      display: none;
    }
    &::before {
      display: none;
    }
  }
`;

export const FlexContainer = styled.div`
  background-color: #142425;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  color: white;
  @media screen and (max-width: 900px) {
    padding: 0;
  }
`;
